<p-fluid class="flex flex-col md:flex-row gap-20" style="padding-left: 2%; padding-right: 2%;">
    <div class="md:w-1/4">
        <div class="card flex flex-col gap-4 items-center">
            <img src="./assets/img/perfildemo.jpg" alt="Perfil" class="rounded-full" />
        </div>
    </div>
    <div class="md:w-3/4">
        <div class="card flex flex-col gap-4">
            <div class="font-semibold text-center text-xl">Datos de Usuario</div>
            <form [formGroup]="formUserUpd">
                <div class="grid grid-cols-12 gap-4">
                    <div class="col-span-6">
                        <p-floatlabel variant="on">
                            <label for="userNameUpd">Nombre</label>
                            <input pInputText formControlName="userNameUpd" id="userNameUpd" type="text" />
                        </p-floatlabel>
                    </div>
                    <div class="col-span-6">
                        <p-floatlabel variant="on">
                            <label for="lastNameUpd">Apellido</label>
                            <input pInputText formControlName="lastNameUpd" id="lastNameUpd" type="text" />
                        </p-floatlabel>
                    </div>

                    <div class="col-span-12">
                        <p-floatlabel variant="on">
                            <label for="addressUserUpd">Dirección</label>
                            <input pInputText formControlName="addressUserUpd" id="addressUserUpd" type="text" />
                        </p-floatlabel>
                    </div>

                    <div class="col-span-4">
                        <p-floatlabel variant="on">
                            <label for="ciUserUpd">Cédula</label>
                            <input pInputText formControlName="ciUserUpd" id="ciUserUpd" type="text" />
                        </p-floatlabel>
                    </div>

                    <div class="col-span-4">
                        <p-floatlabel variant="on">
                            <label for="telUserUpd">Teléfono</label>
                            <input pInputText formControlName="telUserUpd" id="telUserUpd" type="text" />
                        </p-floatlabel>
                    </div>

                    <div class="col-span-4">
                        <p-floatlabel variant="on">
                            <label for="emailUpd">Email</label>
                            <input pInputText formControlName="emailUpd" id="emailUpd" type="email" />
                        </p-floatlabel>
                    </div>

                    <div class="col-span-3">
                        <p-floatlabel variant="on">
                            <label for="userUpd">Usuario</label>
                            <input pInputText formControlName="userUpd" id="userUpd" type="text" />
                        </p-floatlabel>
                    </div>

                    <div class="col-span-3">
                        <p-floatlabel variant="on">
                            <label for="passwordUpd">Contraseña</label>
                            <input pInputText formControlName="passwordUpd" id="passwordUpd" type="password" />
                        </p-floatlabel>
                    </div>

                    <div class="col-span-3">
                        <p-floatlabel variant="on">
                            <label for="passwordReUpd">Repita Contraseña</label>
                            <input pInputText formControlName="passwordReUpd" id="passwordReUpd" type="password" />
                        </p-floatlabel>
                    </div>

                    <div class="col-span-3">
                        <p-floatlabel variant="on">
                            <label for="securePin">PIN DE SEGURIDAD</label>
                            <input pInputText id="securePin" [(ngModel)]="securePin" [ngModelOptions]="{standalone: true}" maxlength="4" placeholder="****" type="password" style="width:100%" [disabled]="!editUserData">
                        </p-floatlabel>
                    </div>

                    <div class="col-span-12">
                        <div class="flex flex-col items-center gap-2">
                            <label class="font-semibold">Firma</label>
                            @if (existingSignature && !editUserData) {
                            <img [src]="existingSignature" alt="Firma actual" style="max-height:100px;border:1px solid #ccc;border-radius:0.5rem;padding:4px" />
                            } @else if (!existingSignature && !editUserData) {
                            <span class="text-sm text-gray-400">Sin firma registrada</span>
                            }
                            @if (editUserData) {
                            <div class="flex flex-col items-center gap-2">
                                @if (signaturePreview) {
                                <img [src]="signaturePreview" alt="Vista previa" style="max-height:80px;border:1px solid #ccc;border-radius:0.5rem;padding:4px" />
                                } @else {
                                <span class="text-sm text-gray-400">Ninguna firma dibujada</span>
                                }
                                <p-button severity="help" icon="pi pi-pencil" label="Dibujar Firma" (click)="openSignatureDialog()"></p-button>
                            </div>
                            }
                        </div>
                    </div>

                    <div class="col-span-12">
                        <div class="flex grid-cols-12 gap-4 justify-center">
                            @if(editUserData){
                            <p-button severity="danger" label="Cancelar" text icon="pi pi-times"
                                (click)="cancelEditUser()" />
                            <p-button severity="success" label="Guardar" text icon="pi pi-check"
                                (click)="savePassword()" />
                            <p-button severity="info" label="Guardar Firma y PIN" text icon="pi pi-save"
                                (click)="saveProfile()" />
                            }
                            @if(!editUserData){
                            <p-button severity="secondary" label="Editar Contraseña" text icon="pi pi-user-edit"
                                (click)="editUser()" />
                            }
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</p-fluid>

<p-dialog [(visible)]="signatureDialogVisible" header="Dibujar Firma" [modal]="true" [style]="{width:'90vw',height:'90vh'}" [closable]="true" [draggable]="false" [resizable]="false">
    <div class="flex flex-col items-center gap-3" style="height:100%">
        <canvas #signatureCanvas width="800" height="400"
            style="border:2px solid #000;border-radius:0.65rem;background:#fff;cursor:crosshair;touch-action:none;width:100%;height:calc(90vh - 130px)"
            (mousedown)="onMouseDown($event)"
            (mousemove)="onMouseMove($event)"
            (mouseup)="onMouseUp()"
            (mouseleave)="onMouseUp()"
            (touchstart)="onTouchStart($event)"
            (touchmove)="onTouchMove($event)"
            (touchend)="onMouseUp()"></canvas>
        <div class="flex gap-3">
            <p-button severity="secondary" icon="pi pi-refresh" label="Limpiar" (click)="clearSignature()"></p-button>
            <p-button severity="success" icon="pi pi-check" label="Aceptar" (click)="acceptSignature()"></p-button>
        </div>
    </div>
</p-dialog>
